export default __webpack_public_path__ + "static/media/twitter.30badd77.svg";